import React, { useState } from "react";
import { useParams } from "react-router-dom";

//import { SubmitHandler } from "react-hook-form";
//import { toast } from "react-toastify";
import { Tab, Tabs } from "react-bootstrap";

import BOCompteSocieteTabMarques from "./components/BOCompteSocieteTabMarques";
import BOCompteSocieteTabActeursJuridiques from "./components/BOCompteSocieteTabActeursJuridiques";
import BOCompteSocieteTabFond from "./components/BOCompteSocieteTabFond";
import SocieteInformationsBO from "./components/SocieteInformationsBO";


const PageBOCompteSociete: React.FC = () => {

  const { idsociete } = useParams();
  const IdSociete = idsociete ?? "";
  const [currTabName, setcurrTabName] = useState("infos");
  const [RaisonSociale, setRaisonSociale] = useState("");




  // /*Acteurs Juridiques */
  // const [sourceActeursJuridiques, setSourceActeursJuridiques] = useState<IKeyValueLibelle[]|undefined>([]);
  // const [destinationActeursJuridiques, setDestinationActeursJuridiques] = useState<IKeyValueLibelle[]|undefined>([]);
  // const [destinationActeursJuridiquesResult, setDestinationActeursJuridiquesResult] = useState<IKeyValueLibelle[]|null>(null);


  // //AJ affectés a la societe
  // const { data: SocieteActeursJuridiquesResult, isFetching: SocieteActeursJuridiquesisFetching, error: SocieteActeursJuridiqueserror } = useFetchBOSocieteActeursJuridiquesQuery(IdSociete, {
  //   refetchOnMountOrArgChange: true,
  //   skip: !keycloakinitialized || !keycloak.authenticated || IdSociete === "",
  // });

 
  

  return (
  <>
   <div className="container text-center">
        <div className="row pt-3 pb-2">
          <div className="col col-12 ">
            <h2 className="titreModule titre-bleu"><i className="bi-person pe-2" />Compte société ({RaisonSociale})</h2>
          </div>
        </div>
        <div className="row pt-3 pb-5">
          <div className="col col-md-10 offset-md-1 col-12 ">
    {
    <>
      <Tabs defaultActiveKey={currTabName} id="uncontrolled-tab-example" onSelect={(key) => setcurrTabName(key ?? "infos")} className="onglet mb-3 ">
        <Tab eventKey="infos" title="Informations générales" key={"test"} >
          <SocieteInformationsBO handleRaisonSociale={setRaisonSociale} IdSociete={parseInt(IdSociete)} ReadOnlyServicePart={false}/>
        </Tab>
        <Tab eventKey="marques" title="Affectation des marques" >
          <BOCompteSocieteTabMarques IdSociete={parseInt(IdSociete)} refetch={currTabName === "marques"}></BOCompteSocieteTabMarques>
        </Tab>
        <Tab eventKey="acteursjuridiques" title="Affectation des acteurs juridiques" >
          <BOCompteSocieteTabActeursJuridiques IdSociete={parseInt(IdSociete)} refetch={currTabName === "acteursjuridiques"} ></BOCompteSocieteTabActeursJuridiques>
        </Tab>
        <Tab eventKey="fondtotal" title="Fonds total affectés">
        <BOCompteSocieteTabFond IdSociete={parseInt(IdSociete)} refetch={currTabName === "fondtotal"} ></BOCompteSocieteTabFond>
        </Tab>
      </Tabs>
    </>
    }
      </div>
           </div>
           </div>
  </>
  )
    
}; 

export default PageBOCompteSociete;

